import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
  CircularProgress,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';

import getReporterValue from '../../../utils/reporterValue';


class ReportedProblemsTable extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        feedback: PropTypes.string,
        reporter: PropTypes.string,
        status: PropTypes.string,
        dateReported: PropTypes.string,
      }),
    ),
    loading: PropTypes.bool,
    onItemClick: PropTypes.func,
    classes: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    data: [],
    loading: false,
    onItemClick: () => { },
  };

  state = {
    page: 0,
    rowsPerPage: 10,
    rowsPageOptions: [],
  };

  handleChangePage = (e, page) => {
    const { loadMore } = this.props;
    const { rowsPerPage } = this.state;

    this.setState({ page });
    loadMore(rowsPerPage);
  }

  renderRows = () => {
    const {
      data,
      onItemClick,
      classes,
    } = this.props;

    const { page, rowsPerPage } = this.state;

    return data
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map(reportedProblem => (
        <TableRow
          hover
          key={reportedProblem.uuid}
          onClick={() => onItemClick(reportedProblem)}
          classes={{
            hover: classes.tableRow,
          }}
        >
          <TableCell className={classes.tableCell}>{reportedProblem.feedback}</TableCell>
          <TableCell className={classes.tableCell}>{getReporterValue(reportedProblem)}</TableCell>
          <TableCell className={classes.tableCell}>{reportedProblem.state}</TableCell>
          <TableCell className={classes.tableCell}>{reportedProblem.createdAt}</TableCell>
        </TableRow>
      ));
  }

  renderContent = () => {
    const {
      data,
      loading,
      classes,
    } = this.props;

    switch (true) {
      case loading:
        return (
          <TableRow>
            <TableCell colSpan={5} padding="none" className={classes.loading}>
              <CircularProgress thickness={5} size={80} />
            </TableCell>
          </TableRow>
        );
      case !data.length:
        return (
          <TableRow>
            <TableCell colSpan={5} padding="none" className={classes.loading}>
              <Typography variant="display1">Sorry, seems there&apos;s no content to display</Typography>
            </TableCell>
          </TableRow>
        );
      default:
        return this.renderRows();
    }
  }

  render() {
    const { totalCount, classes } = this.props;
    const { page, rowsPerPage, rowsPageOptions } = this.state;

    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>Feedback</TableCell>
              <TableCell className={classes.tableHead}>Reported By</TableCell>
              <TableCell className={classes.tableHead}>Status</TableCell>
              <TableCell className={classes.tableHead}>Reported Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.renderContent()}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={4}
                rowsPerPageOptions={rowsPageOptions}
                rowsPerPage={rowsPerPage}
                page={page}
                count={totalCount}
                SelectProps={{ native: true }}
                onChangePage={this.handleChangePage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

export default withStyles(theme => ({
  loading: {
    textAlign: 'center',
    padding: `${theme.spacing.unit * 10}px !important`,
  },
  tableHead: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  tableCell: {
    border: 'none',
  },
  tableRow: {
    '&&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(ReportedProblemsTable);
